<template>
  <div class="my-4" :class="classes">
    <NuxtLink :to="post?.path" class="block">
      <PostsCard :post="post" :label="block.data?.label" :image-position="block.data?.imagePosition" />
    </NuxtLink>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
    props.block.data?.align === 'left' ? 'max-w-3xl' : null, 
    props.block.data?.align === 'center' ? 'w-full max-w-3xl mx-auto' : null,
  ].filter(str => str).join(' ')

const post = computed(() => ({
  ...props.block?.data?.post,
  path: props.block.data?.path || props.block?.data?.post?.path,
  title: props.block.data?.title || props.block?.data?.post?.title,
  excerpt: props.block.data?.excerpt || props.block?.data?.post?.excerpt,
  image: props.block.data?.image || props.block?.data?.post?.image,
}))
</script>
